module.exports = __webpack_public_path__ + "img/back-bottom-token.13461f76.png";